
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Apps from './Application.js'
import Login from './Login.js'
import Profile from './Profilepage.js'
import CAS from './CASloginpage.js'
import './App.css';


function App() {
  const basename = process.env.REACT_APP_ROUTER_BASE || "/";
  return (

    <div>

    <BrowserRouter basename={basename}>
    <Routes>
    <Route path="login" element={<Login />} />
    <Route path="/" element={<Login />} />
      <Route path="profile" element={<Profile />} />
      <Route path="landing" element={<Apps />} />
      <Route path="caslogin" element={<CAS />} />



    </Routes>
    </BrowserRouter>

    </div>

  );
}

export default App;